// Carousels for the custom blog content (snippets/blog-custom-*.liquid).
// Slides per view come from data-mobile / data-tablet / data-desktop; the
// breakpoints match the pre-init layout in section-blog-custom-content.css.

if (!customElements.get('blog-custom-carousel')) {
	class BlogCustomCarousel extends HTMLElement {
		connectedCallback() {
			if (typeof Swiper === 'undefined') {
				window.addEventListener('load', () => this.init(), { once: true });
				return;
			}
			this.init();
		}

		disconnectedCallback() {
			if (this.mediaObserver) this.mediaObserver.disconnect();
			if (this.swiper) this.swiper.destroy(true, true);
			this.swiper = null;
		}

		init() {
			if (this.swiper || typeof Swiper === 'undefined' || !this.isConnected) return;

			const perView = (value, fallback) => {
				const number = parseFloat(value);
				return Number.isNaN(number) || number <= 0 ? fallback : number;
			};

			this.swiper = new Swiper(this.querySelector('.swiper'), {
				slidesPerView: perView(this.dataset.mobile, 1.5),
				spaceBetween: 16,
				watchOverflow: true,
				keyboard: { enabled: true, onlyInViewport: true },
				navigation: {
					prevEl: this.querySelector('.blog-custom__arrow--prev'),
					nextEl: this.querySelector('.blog-custom__arrow--next'),
				},
				pagination: {
					el: this.querySelector('.blog-custom__dots'),
					clickable: true,
				},
				breakpoints: {
					750: {
						slidesPerView: perView(this.dataset.tablet, 3),
						spaceBetween: 20,
					},
					1100: {
						slidesPerView: perView(this.dataset.desktop, 4),
						spaceBetween: 24,
					},
				},
			});

			this.classList.add('is-initialized');
			this.centerArrowsOnMedia();
		}

		// Product and collection cards have text under the image, so the arrows
		// are centred on the image rather than on the whole card.
		centerArrowsOnMedia() {
			const media = this.querySelector(this.dataset.mediaSelector || 'img');
			if (!media || typeof ResizeObserver === 'undefined') return;

			const update = () => {
				const height = media.offsetHeight;
				if (height > 0) this.style.setProperty('--arrow-top', `${height / 2}px`);
			};

			this.mediaObserver = new ResizeObserver(update);
			this.mediaObserver.observe(media);
			update();
		}
	}

	customElements.define('blog-custom-carousel', BlogCustomCarousel);
}
